import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import {
  getFavoriteActivitiesFilteredListSize,
  getFavoriteActivitiesListFilteredForPage,
  getFavoriteActivitiesPendingGetAll,
} from 'store/entities/favoriteActivities/selectors'
import { favoriteActivities } from 'store/entities/favoriteActivities/actions'
import FavoriteActivitiesList from './FavoriteActivitiesList'

const mapStateToProps = createStructuredSelector({
  size: getFavoriteActivitiesFilteredListSize,
  list: getFavoriteActivitiesListFilteredForPage,
  pendingGetAll: getFavoriteActivitiesPendingGetAll,
})

const mapDispatchToProps = {
  removeFromFavorites: favoriteActivities.delete.request,
}

export default connect(mapStateToProps, mapDispatchToProps)(FavoriteActivitiesList)
